import { createContext } from "react";
import IBaseListingResponse from "../../../utils/api/base-listing-response";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../../utils/helpers/constants";
import { IBinQuery } from "../../../models/wms/bin/query";
import { IBin, IBinDetails } from "../../../models/wms/bin/response";
import { ICreateBin, IUpdateBin } from "../../../models/wms/bin/request";

export type BinLoading =
  | "list"
  | "details"
  | "create"
  | "update"
  | "delete";

export interface IInternalState {
  loading: BinLoading[];
  list?: IBaseListingResponse<IBin>;
  query: IBinQuery;
  details?: IBinDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: IBinDetails) => void;
    createBin: (request: ICreateBin) => void;
    updateBin: (id: number, request: IUpdateBin) => void;
    deleteBin: (id: number) => void;
    reorderBin: (id: number, pickSequence: number) => void;
    setSearch: (search?: string) => void;
    setQuery: (query: IBinQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    createBin: DEFAULT_FUNCTION,
    updateBin: DEFAULT_FUNCTION,
    deleteBin: DEFAULT_FUNCTION,
    reorderBin: DEFAULT_FUNCTION,
    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const BinContext = createContext(externalState);
export default BinContext;
